import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useParams } from 'react-router-dom'

import { FinancialUpdatePaymentInstructionTxSchemas } from 'schemas/financialUpdatePaymentInstructionTxSchemas'
import { FinancialUpdatePaymentInstructionTxTypes } from 'types/financialUpdatePaymentInstructionTxTypes'
import { PaymentInstructionsDataTypes } from 'types/financials'
import { useEffect } from 'react'

export const usePaymentInstructionTxForm = ({
  selectedRowData,
}: {
  selectedRowData: PaymentInstructionsDataTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<FinancialUpdatePaymentInstructionTxTypes>({
    resolver: zodResolver(FinancialUpdatePaymentInstructionTxSchemas),
    defaultValues: {
      paymentId: selectedRowData.id,
      traderId: selectedRowData.traderId,
      instructionName: selectedRowData.instructionName,
      frequency: selectedRowData.frequencyId,
      bankAccountNumber: selectedRowData.bankAccountNumber,
      paymentAmount: selectedRowData.paymentAmount,
      firstPaymentDate: selectedRowData.firstPaymentDate,
      endPaymentDate: selectedRowData.endPaymentDate,
      reasonId: 1,
    },
  })

  // useEffect(() => {
  //   reset(selectedRowData)
  // }, [reset, selectedRowData])

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    watch,
  }
}
